const dropdownButton = document.getElementById('dropdownButton');
if(dropdownButton){
  const dropdownMenu = document.getElementById('dropdownMenu');
  const currentSelection = document.getElementById('dropdownCurrent');
  const dropdownOptions = dropdownMenu.querySelectorAll('.c-query-dropdown_option');

  // SORT DROPDOWN BUTTON CLICK
  dropdownButton.addEventListener('click', function(e){
    e.stopPropagation();
    const showDropdownMenu = dropdownMenu.style.display === 'block';
    dropdownMenu.style.display = showDropdownMenu ? 'none' : 'block';
    dropdownButton.setAttribute('aria-expanded', !showDropdownMenu);
  });

  // UPDATE SELECTED OPTION
  const stateFilterInput = document.getElementById('state-filter-value');

  dropdownOptions.forEach(option => {
    option.addEventListener('click', (e) => {
      const isAlreadyActive = option.classList.contains('active');

      dropdownOptions.forEach(o=>o.classList.remove('active'));
      dropdownOptions.forEach(o=>o.setAttribute('aria-selected','false'));
      dropdownMenu.style.display = 'none';
      dropdownButton.setAttribute('aria-expanded', false);

      if (isAlreadyActive) {
        // Deselect: clear the filter
        currentSelection.textContent = 'Select state';
        if (stateFilterInput) {
          stateFilterInput.value = '';
          stateFilterInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        option.classList.add('active');
        option.setAttribute('aria-selected','true');
        currentSelection.textContent = option.textContent;
        if (stateFilterInput) {
          stateFilterInput.value = option.querySelector('span').textContent.trim();
          stateFilterInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  });

  // HIDE IF CLICK OUTSIDE
  document.addEventListener('click', function(e){
    if(dropdownMenu.style.display === 'block'){
      dropdownMenu.style.display = 'none';
      dropdownButton.setAttribute('aria-expanded', false);
    }
  });
}